import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export enum DeepResearchToolType {
  // Supervisor-level tools
  ResearchSubAgent = 'ResearchSubAgent',
  Think = 'Think',
  CompleteAnswer = 'CompleteAnswer',

  // Sub-agent tools
  SearchTool = 'SearchTool',
  GetWarehouseOverviewTool = 'GetWarehouseOverviewTool',
  QueryWarehouseTool = 'QueryWarehouseTool',
  NotebookQueryTool = 'NotebookTool',
  AttachmentTool = 'AttachmentTool',
}

export const TOOL_DESCRIPTIONS = {
  [DeepResearchToolType.ResearchSubAgent]: 'Researching',
  [DeepResearchToolType.Think]: 'Thinking',
  [DeepResearchToolType.CompleteAnswer]: 'Writing report',
  [DeepResearchToolType.SearchTool]: 'Searching benchling',
  [DeepResearchToolType.GetWarehouseOverviewTool]: 'Getting warehouse overview',
  [DeepResearchToolType.QueryWarehouseTool]: 'Querying warehouse',
  [DeepResearchToolType.NotebookQueryTool]: 'Reading notebook',
  [DeepResearchToolType.AttachmentTool]: 'Reading attachment',
};

export const TOOL_ICONS: Record<DeepResearchToolType, BenchlingIconName> = {
  [DeepResearchToolType.ResearchSubAgent]: 'magic-wand',
  [DeepResearchToolType.Think]: 'lightbulb',
  [DeepResearchToolType.CompleteAnswer]: 'file',
  [DeepResearchToolType.SearchTool]: 'magnifying-glass',
  [DeepResearchToolType.GetWarehouseOverviewTool]: 'warehouse-full',
  [DeepResearchToolType.QueryWarehouseTool]: 'warehouse-full',
  [DeepResearchToolType.NotebookQueryTool]: 'file',
  [DeepResearchToolType.AttachmentTool]: 'file',
};

export enum ToolCallStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export interface BaseProgressToolCall {
  tool: DeepResearchToolType;
  toolId: string;
  createdAt: Date;
  status: ToolCallStatus;
  responseText?: string;
}
export interface SearchToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.SearchTool;
  query: string;
  objectTypes: Array<string>;
}

export interface GetWarehouseOverviewToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.GetWarehouseOverviewTool;
}

export interface QueryWarehouseToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.QueryWarehouseTool;
  query: string;
}

export interface NotebookQueryToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.NotebookQueryTool;
  notebookId: string;
}

export interface AttachmentToolCall extends BaseProgressToolCall {
  tool: DeepResearchToolType.AttachmentTool;
  attachmentId: string;
}

export type ProgressToolCall =
  | SearchToolCall
  | GetWarehouseOverviewToolCall
  | QueryWarehouseToolCall
  | NotebookQueryToolCall
  | AttachmentToolCall
  | BaseProgressToolCall; // We include base for any unsupported tool calls
